
    import hoverEffect from "./hover-effect.js";

    // Exécuter seulement si l'écran a une largeur maximale de 768px
    Array.from(document.querySelectorAll(".proj")).forEach((e) => {
      const imgs = Array.from(e.querySelectorAll("img"));
      new hoverEffect({
        parent: e,
        intensity: 0.3,
        image1: imgs[0].getAttribute("src"),
        image2: imgs[1].getAttribute("src"),
        displacementImage: "/img/hoverEffect/7.jpg",
      });
    });
  